async function inject(id, path){
  const el = document.getElementById(id);
  if(!el) return;
  const html = await (await fetch(path)).text();
  el.innerHTML = html;
}

// ドロップダウンメニューの機能
window.initDropdownMenus = function() {
  const navItems = document.querySelectorAll('.nav-item');
  
  navItems.forEach(item => {
    const link = item.querySelector('.nav-link');
    const subNav = item.querySelector('.sub-nav');
    
    if (subNav) {
      // クリックイベントを追加
      link.addEventListener('click', (e) => {
        e.preventDefault();
        
        // 他のメニューを閉じる
        navItems.forEach(otherItem => {
          if (otherItem !== item) {
            otherItem.classList.remove('active');
            const otherSubNav = otherItem.querySelector('.sub-nav');
            if (otherSubNav) {
              otherSubNav.style.display = 'none';
            }
          }
        });
        
        // 現在のメニューの開閉
        item.classList.toggle('active');
        if (item.classList.contains('active')) {
          subNav.style.display = 'block';
        } else {
          subNav.style.display = 'none';
        }
      });
      
      // サブメニューのホバー機能
      const subItems = subNav.querySelectorAll('li');
      subItems.forEach(subItem => {
        const subSubNav = subItem.querySelector('.sub-sub-nav');
        if (subSubNav) {
          subItem.addEventListener('mouseenter', () => {
            subSubNav.style.display = 'block';
          });
          
          subItem.addEventListener('mouseleave', () => {
            subSubNav.style.display = 'none';
          });
        }
      });
    }
  });
  
  // メニュー外をクリックした時に閉じる
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.nav-item')) {
      navItems.forEach(item => {
        item.classList.remove('active');
        const subNav = item.querySelector('.sub-nav');
        if (subNav) {
          subNav.style.display = 'none';
        }
      });
    }
  });
};

// ヒーロースライダーの機能
function initHeroSlider() {
  const slider = document.querySelector('.hero-slider');
  if (!slider) return;

  const slides = slider.querySelectorAll('.hero-slide');
  const prevBtn = slider.querySelector('.hero-nav-prev');
  const nextBtn = slider.querySelector('.hero-nav-next');
  const paginationDots = slider.querySelectorAll('.hero-pagination-dot');
  
  let currentSlide = 0;
  let autoSlideInterval;
  const slideInterval = 5000; // 5秒間隔

  // スライドを切り替える関数
  function goToSlide(index) {
    // 現在のスライドを非アクティブにする
    slides[currentSlide].classList.remove('active');
    paginationDots[currentSlide].classList.remove('active');
    
    // 新しいスライドをアクティブにする
    currentSlide = index;
    slides[currentSlide].classList.add('active');
    paginationDots[currentSlide].classList.add('active');
  }

  // 次のスライドに進む
  function nextSlide() {
    const nextIndex = (currentSlide + 1) % slides.length;
    goToSlide(nextIndex);
  }

  // 前のスライドに戻る
  function prevSlide() {
    const prevIndex = (currentSlide - 1 + slides.length) % slides.length;
    goToSlide(prevIndex);
  }

  // 自動スライドを開始
  function startAutoSlide() {
    autoSlideInterval = setInterval(nextSlide, slideInterval);
  }

  // 自動スライドを停止
  function stopAutoSlide() {
    if (autoSlideInterval) {
      clearInterval(autoSlideInterval);
    }
  }
    // イベントリスナーを設定
  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      prevSlide();
      stopAutoSlide();
      startAutoSlide();
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      nextSlide();
      stopAutoSlide();
      startAutoSlide();
    });
  }

  // ページネーションドットのクリックイベント
  paginationDots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      goToSlide(index);
      stopAutoSlide();
      startAutoSlide();
    });
  });

  // マウスホバー時に自動スライドを一時停止
  slider.addEventListener('mouseenter', stopAutoSlide);
  slider.addEventListener('mouseleave', startAutoSlide);

  // 自動スライドを開始
  startAutoSlide();
}

// カルーセル機能の初期化
function initCarousel() {
  const carousels = document.querySelectorAll('[data-slider-track]');
  
  carousels.forEach(track => {
    const container = track.closest('.home-products__container, .home-ranking__container');
    if (!container) return;
    
    const items = track.querySelectorAll('[data-slider-item]');
    const prevBtn = container.querySelector('[data-slider-prev]');
    const nextBtn = container.querySelector('[data-slider-next]');
    
    if (items.length <= 3) {
      // アイテムが3個以下の場合はコントロールを非表示
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
      return;
    }
    
    let currentIndex = 0;
    const itemsPerView = window.innerWidth <= 480 ? 1 : window.innerWidth <= 768 ? 2 : window.innerWidth <= 1024 ? 3 : 4;
    const maxIndex = Math.max(0, items.length - itemsPerView);
    
    function updateCarousel() {
      const translateX = -currentIndex * (100 / itemsPerView);
      track.style.transform = `translateX(${translateX}%)`;
    }
    
    function nextSlide() {
      if (currentIndex < maxIndex) {
        currentIndex++;
        updateCarousel();
      }
    }
    
    function prevSlide() {
      if (currentIndex > 0) {
        currentIndex--;
        updateCarousel();
      }
    }
    
    if (prevBtn) {
      prevBtn.addEventListener('click', prevSlide);
    }
    
    if (nextBtn) {
      nextBtn.addEventListener('click', nextSlide);
    }
    
    // レスポンシブ対応
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        const newItemsPerView = window.innerWidth <= 480 ? 1 : window.innerWidth <= 768 ? 2 : window.innerWidth <= 1024 ? 3 : 4;
        const newMaxIndex = Math.max(0, items.length - newItemsPerView);
        
        if (currentIndex > newMaxIndex) {
          currentIndex = newMaxIndex;
        }
        
        updateCarousel();
      }, 250);
    });
    
    // 初期表示
    updateCarousel();
  });
}



// カレンダーの機能
function initCalendar() {
  const calendarDays0 = document.getElementById('calendarDays0') || document.getElementById('calendarDays');
  const calendarDays1 = document.getElementById('calendarDays1');
  const currentMonthElement0 = document.getElementById('currentMonth0') || document.getElementById('currentMonth');
  const currentMonthElement1 = document.getElementById('currentMonth1');
  const prevMonthBtn = document.getElementById('prevMonth');
  const nextMonthBtn = document.getElementById('nextMonth');

  if (!calendarDays0 || !currentMonthElement0) return;

  let currentDate = new Date();
  let currentYear = currentDate.getFullYear();
  let currentMonth = currentDate.getMonth();

  // 祝日データ（2024年の主要な祝日）
  const holidays = {
    '2024-01-01': '元日',
    '2024-01-08': '成人の日',
    '2024-02-11': '建国記念の日',
    '2024-02-12': '振替休日',
    '2024-02-23': '天皇誕生日',
    '2024-03-20': '春分の日',
    '2024-04-29': '昭和の日',
    '2024-05-03': '憲法記念日',
    '2024-05-04': 'みどりの日',
    '2024-05-05': 'こどもの日',
    '2024-05-06': '振替休日',
    '2024-07-15': '海の日',
    '2024-08-11': '山の日',
    '2024-08-12': '振替休日',
    '2024-09-16': '敬老の日',
    '2024-09-22': '秋分の日',
    '2024-09-23': '振替休日',
    '2024-10-14': 'スポーツの日',
    '2024-11-03': '文化の日',
    '2024-11-04': '振替休日',
    '2024-11-23': '勤労感謝の日',
    '2025-01-01': '元日',
    '2025-01-13': '成人の日',
    '2025-02-11': '建国記念の日',
    '2025-02-23': '天皇誕生日',
    '2025-02-24': '振替休日',
    '2025-03-21': '春分の日',
    '2025-04-29': '昭和の日',
    '2025-05-03': '憲法記念日',
    '2025-05-04': 'みどりの日',
    '2025-05-05': 'こどもの日',
    '2025-05-06': '振替休日',
    '2025-07-21': '海の日',
    '2025-08-11': '山の日',
    '2025-09-15': '敬老の日',
    '2025-09-23': '秋分の日',
    '2025-10-13': 'スポーツの日',
    '2025-11-03': '文化の日',
    '2025-11-23': '勤労感謝の日',
    '2025-11-24': '振替休日'
  };

  // 管理画面の設定（window.calendarConfig）から追加の祝日や定休日（曜日）をマージ
  const closedWeekdays = new Set();
  // デフォルトで日曜を定休日にする互換性
  closedWeekdays.add(0);
  // 個別定休日を格納するセット
  const closedDatesSet = new Set();

  if (window.calendarConfig) {
    Object.values(window.calendarConfig).forEach(cfg => {
      if (!cfg) return;
      // 固定祝日リスト: "YYYY-MM-DD:Label,YYYY-MM-DD:Label"
      if (cfg.holidaysList) {
        cfg.holidaysList.split(',').forEach(item => {
          const parts = item.split(':').map(s => s.trim());
          if (parts[0]) {
            holidays[parts[0]] = parts[1] || '';
          }
        });
      }

      if (cfg.closedSun) closedWeekdays.add(0);
      if (cfg.closedMon) closedWeekdays.add(1);
      if (cfg.closedTue) closedWeekdays.add(2);
      if (cfg.closedWed) closedWeekdays.add(3);
      if (cfg.closedThu) closedWeekdays.add(4);
      if (cfg.closedFri) closedWeekdays.add(5);
      if (cfg.closedSat) closedWeekdays.add(6);
      // 個別の定休日（YYYY-MM-DD のカンマ区切り）をセットに追加
      if (cfg.closedDates) {
        const parts = String(cfg.closedDates).split(',').map(s => s.trim()).filter(Boolean);
        parts.forEach(d => {
          // 正規化: YYYY-MM-DD のみ受け付ける
          const m = d.match(/^\d{4}-\d{2}-\d{2}$/);
          if (m) {
            closedDatesSet.add(d);
          }
        });
      }
    });
  }

  // 日付をフォーマットする関数
  function formatDate(year, month, day) {
    return `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
  }

  // カレンダーを描画するヘルパー（container に monthOffset を適用）
  function renderCalendarFor(container, monthElement, monthOffset) {
    const year = new Date(currentYear, currentMonth + monthOffset, 1).getFullYear();
    const monthIndex = new Date(currentYear, currentMonth + monthOffset, 1).getMonth();
    const firstDay = new Date(year, monthIndex, 1);
    const startDate = new Date(firstDay);
    startDate.setDate(startDate.getDate() - firstDay.getDay());

    const monthNames = ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'];
    if (monthElement) monthElement.textContent = `${year}年${monthNames[monthIndex]}`;

    let calendarHTML = '';
    const today = new Date();

    for (let i = 0; i < 42; i++) {
      const date = new Date(startDate);
      date.setDate(startDate.getDate() + i);

      const day = date.getDate();
      const isCurrentMonth = date.getMonth() === monthIndex;
      const isToday = date.toDateString() === today.toDateString();
      const dateString = formatDate(date.getFullYear(), date.getMonth(), date.getDate());
      const isHoliday = holidays[dateString];
      const isSunday = date.getDay() === 0;
      const isClosedSpecificDate = closedDatesSet.has(dateString);
      const isRegularHoliday = isHoliday || closedWeekdays.has(date.getDay()) || isClosedSpecificDate;

      let className = 'calendar-day';
      if (!isCurrentMonth) className += ' other-month';
      if (isToday) className += ' today';
      if (isRegularHoliday) className += ' holiday';

      calendarHTML += `<div class="${className}" data-date="${dateString}">${day}</div>`;
    }

    container.innerHTML = calendarHTML;
  }

  // 前月ボタンのイベント
  if (prevMonthBtn) {
    prevMonthBtn.addEventListener('click', () => {
      currentMonth--;
      if (currentMonth < 0) {
        currentMonth = 11;
        currentYear--;
      }
      renderCalendarFor(calendarDays0, currentMonthElement0, 0);
      if (calendarDays1) renderCalendarFor(calendarDays1, currentMonthElement1, 1);
    });
  }

  // 次月ボタンのイベント
  if (nextMonthBtn) {
    nextMonthBtn.addEventListener('click', () => {
      currentMonth++;
      if (currentMonth > 11) {
        currentMonth = 0;
        currentYear++;
      }
      renderCalendarFor(calendarDays0, currentMonthElement0, 0);
      if (calendarDays1) renderCalendarFor(calendarDays1, currentMonthElement1, 1);
    });
  }

  // 初期表示（今月と来月）
  renderCalendarFor(calendarDays0, currentMonthElement0, 0);
  if (calendarDays1) renderCalendarFor(calendarDays1, currentMonthElement1, 1);
}

// 商品スライダーの機能
function initProductCarousel() {
  const carousels = document.querySelectorAll('.product-carousel');
  
  carousels.forEach(carousel => {
    const track = carousel.querySelector('.carousel-track');
    const prevBtn = carousel.querySelector('.carousel-nav--prev');
    const nextBtn = carousel.querySelector('.carousel-nav--next');
    const products = track.querySelectorAll('.card--product');
    
    let currentIndex = 0;
    const productsPerView = 3;
    const totalProducts = products.length;
    const maxIndex = totalProducts - productsPerView;

    // スライダーを移動する関数
    function moveCarousel(index) {
      // ループ機能: 最後を超えたら最初に、最初より前なら最後に
      if (index < 0) index = maxIndex;
      if (index > maxIndex) index = 0;
      
      currentIndex = index;
      const translateX = -currentIndex * (100 / productsPerView);
      track.style.transform = `translateX(${translateX}%)`;
      
      // ボタンは常に有効にする（ループするため）
      prevBtn.disabled = false;
      nextBtn.disabled = false;
      prevBtn.style.opacity = '1';
      nextBtn.style.opacity = '1';
      prevBtn.style.cursor = 'pointer';
      nextBtn.style.cursor = 'pointer';
    }

    // 前の商品に移動
    function prevSlide() {
      moveCarousel(currentIndex - 1);
    }

    // 次の商品に移動
    function nextSlide() {
      moveCarousel(currentIndex + 1);
    }

    // イベントリスナーを設定
    if (prevBtn) {
      prevBtn.addEventListener('click', prevSlide);
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', nextSlide);
    }

    // 初期状態を設定
    moveCarousel(0);
  });
}

// 動画スライダーの機能
function initVideoCarousel() {
  const carousels = document.querySelectorAll('.video-carousel');
  
  carousels.forEach(carousel => {
    const track = carousel.querySelector('.carousel-track');
    const prevBtn = carousel.querySelector('.carousel-nav--prev');
    const nextBtn = carousel.querySelector('.carousel-nav--next');
    const videos = track.querySelectorAll('.card--video');
    
    let currentIndex = 0;
    const videosPerView = 3;
    const totalVideos = videos.length;
    const maxIndex = totalVideos - 1; // 最後の動画まで表示できるように修正

    // スライダーを移動する関数
    function moveCarousel(index) {
      // ループ機能: 最後を超えたら最初に、最初より前なら最後に
      if (index < 0) index = maxIndex;
      if (index > maxIndex) index = 0;
      
      currentIndex = index;
      const translateX = -currentIndex * (100 / videosPerView);
      track.style.transform = `translateX(${translateX}%)`;
      
      // ボタンは常に有効にする（ループするため）
      prevBtn.disabled = false;
      nextBtn.disabled = false;
      prevBtn.style.opacity = '1';
      nextBtn.style.opacity = '1';
      prevBtn.style.cursor = 'pointer';
      nextBtn.style.cursor = 'pointer';
    }

    // 前の動画に移動
    function prevSlide() {
      moveCarousel(currentIndex - 1);
    }

    // 次の動画に移動
    function nextSlide() {
      moveCarousel(currentIndex + 1);
    }

    // イベントリスナーを設定
    if (prevBtn) {
      prevBtn.addEventListener('click', prevSlide);
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', nextSlide);
    }

    // 初期状態を設定
    moveCarousel(0);
  });
}

// ヘッダーとフッターコンポーネントを読み込む（絶対パス版）
document.addEventListener('DOMContentLoaded', function() {
    // ヘッダーの読み込み
    const headerContainer = document.getElementById('app-header');
    if (headerContainer) {
        fetch('/src/components/header.html')
            .then(response => response.text())
            .then(html => {
                headerContainer.innerHTML = html;
                // ヘッダー読み込み後にドロップダウンメニューを初期化
                setTimeout(() => {
                    initDropdownMenus();
                }, 50);
            })
            .catch(error => {
                console.error('ヘッダーの読み込みに失敗しました:', error);
            });
    }

    // フッターの読み込み
    const footerContainer = document.getElementById('app-footer');
    if (footerContainer) {
        fetch('/src/components/footer.html')
            .then(response => response.text())
            .then(html => {
                footerContainer.innerHTML = html;
            })
            .catch(error => {
                console.error('フッターの読み込みに失敗しました:', error);
            });
    }
});

window.addEventListener('DOMContentLoaded', ()=>{
  // 現在のページパスを取得
  const currentPath = window.location.pathname;
  
  // 商品詳細ページの場合のパス調整
  if (currentPath.includes('/product/detail')) {
    // 商品詳細ページ用のパス
    inject('app-header','../../components/header.html');
    inject('app-hero','../../components/hero.html');
    inject('app-sidebar-left','../../components/sidebar-left.html');
    inject('app-footer','../../components/footer.html');
  } else {
    // 通常のページ用のパス
    inject('app-header','../components/header.html');
    inject('app-hero','../components/hero.html');
    inject('app-sidebar-left','../components/sidebar-left.html');
    inject('app-footer','../components/footer.html');
  }
  
  // コンポーネント読み込み後にドロップダウンメニューとヒーロースライダーとカレンダーと商品スライダーと動画スライダーとカルーセルを初期化
  setTimeout(() => {
    initDropdownMenus();
    initHeroSlider();
    initCalendar();
    initProductCarousel();
    initVideoCarousel();
    initCarousel();
  }, 100);
});

// 商品詳細ページ専用のコンポーネント読み込み（フォールバック）
document.addEventListener('DOMContentLoaded', function() {
    const currentPath = window.location.pathname;
    
    // 商品詳細ページの場合のみ実行
    if (currentPath.includes('/product/detail')) {
        // ヘッダーの読み込み
        const headerContainer = document.getElementById('app-header');
        if (headerContainer && !headerContainer.innerHTML.trim()) {
            fetch('/src/components/header.html')
                .then(response => response.text())
                .then(html => {
                    headerContainer.innerHTML = html;
                    // ヘッダー読み込み後にドロップダウンメニューを初期化
                    setTimeout(() => {
                        initDropdownMenus();
                    }, 50);
                })
                .catch(error => {
                    console.error('商品詳細ページのヘッダー読み込みに失敗しました:', error);
                });
        }

        // フッターの読み込み
        const footerContainer = document.getElementById('app-footer');
        if (footerContainer && !footerContainer.innerHTML.trim()) {
            fetch('/src/components/footer.html')
                .then(response => response.text())
                .then(html => {
                    footerContainer.innerHTML = html;
                })
                .catch(error => {
                    console.error('商品詳細ページのフッター読み込みに失敗しました:', error);
                });
        }
    }
});
